import { useQuery } from "@tanstack/react-query";

import { quoteRequestsQuotesQuery } from "../infra/quoteRequestsQuotes.query";

export const useQuoteRequestsQuotes = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...quoteRequestsQuotesQuery(id) });

  return { quotes: data ?? [], ...rest };
};
